import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { requestErrorHandler } from 'utils';
import {
  DeleteUserRegionalActions,
  DeleteUserRegionalRequest,
} from 'store/ducks/settings/users';

export function* deleteUserRegionalRequest(action: any) {
  try {
    const { userId, regionalId, onSuccess } = action as DeleteUserRegionalRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/user-regionals/${userId}/${regionalId}`
    );

    const { data } = responseBody;
    yield put(DeleteUserRegionalActions.success(data));
    notify('success', 'Regional removido com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteUserRegionalActions.failure(errorMessage));
  }
}
